import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";
import {
  BookingApiPlaneListRequest,
  PageModel
} from "../../../proto/generated/api_entities_pb";
import {InitialPage} from "../../constans/pagination/pagination";
import {PageModelLimits} from "../../constans/pagination/pageModelLimits";
import {API} from "../../../API/API";

export async function fetchPlaneModels(search?: string): Promise<DebounceSelectOptionProps[]> {
  const req = new BookingApiPlaneListRequest()
    .setQuery(search ?? "")
    .setPagemodel(
      new PageModel().setPage(InitialPage).setLimit(PageModelLimits.Select)
    );

  const planeList = await API.getPlaneList(req);

  // Получаем уникальные модели/регистрационные номера
  const modelsMap = new Map<string, { label: string; value: string }>();
  
  planeList.getPlanesList().forEach(plane => {
    const registrationNumber = plane.getRegistrationnumber();
    const planeTypeName = plane.getPlanetype()?.getName() || '';
    
    // Используем комбинацию типа и регистрационного номера как label
    const label = planeTypeName 
      ? `${planeTypeName} (${registrationNumber})`
      : registrationNumber;
    
    // Используем регистрационный номер как значение для поиска
    if (registrationNumber && !modelsMap.has(registrationNumber)) {
      modelsMap.set(registrationNumber, {
        label,
        value: registrationNumber,
      });
    }
  });

  return Array.from(modelsMap.values()).map(model => ({
    label: model.label,
    value: model.value,
  }));
}

